import { toJS } from 'mobx';
import React from 'react';
import Moment from 'moment-timezone';
import { debounce } from 'lodash';
import Helmet from 'react-helmet';
import queryString from 'query-string';

import failureStore from 'modules/report/stores/failure';
import { LOADING } from 'stores/BaseStore';
import appStore from 'stores/app';

import Header from './components/Header';
import Filter from './components/Filter';
import FailureResults from './components/FailureResults';
import { ReportBody } from '@/components/reports/body';

class FailureLayout extends React.Component {
  state = {
    filterOpen: false,
    searchTerm: 'teste',
    params: {
      searchStartDate: Moment.tz(appStore.timezone).startOf('day'),
      searchEndDate: Moment.tz(appStore.timezone).endOf('day'),
      timeZone: null
    }
  }

  loadData = () => {
    failureStore.getFailure(this.state.params);
    this.setState({searchTerm: ''});
  }

  componentDidMount () {
    const query = queryString.parse(this.props.location.search);
    let params = this.state.params;
    if (query.siteId) {
      params.siteId = query.siteId;
    }

    if (query.startDate) {
      params.searchStartDate = Moment(query.startDate, 'MM-DD-YYYY');
    }

    if (query.endDate) {
      params.searchEndDate = Moment(query.endDate, 'MM-DD-YYYY');
    }

    this.setState({params}, this.loadData);
  }
  
  handleClickFilter = () => {
    this.setState({ filterOpen: !this.state.filterOpen });
  }

  handleChangeSearch = (value) => {
    failureStore.search(value);
  }

  handleChangeDates = ({startDate, endDate}) => {
    let params = this.state.params;
    params.searchStartDate = startDate;
    params.searchEndDate = endDate;
    this.setState({params}, () => {
      if (startDate && endDate) {
        this.loadData();
      }
    });
  }

  handleFilterClose = () => {
    this.setState({filterOpen: false});
  }

  handleFilterApply = (params) => {
    this.setState({
      params,
      filterOpen: false
    }, this.loadData);
  }

  render () {
    const isLoading = failureStore.status === LOADING;

    return (
      <>
        <Helmet title="Failure" />
        <Header
          onClickFilter={this.handleClickFilter}
          onChangeDates={this.handleChangeDates}
          dates={{ startDate: this.state.params.searchStartDate, endDate: this.state.params.searchEndDate }}
          sync={this.loadData}
          isLoading={isLoading}
        />
        {this.renderFilter()}
        <ReportBody>
          <FailureResults data={toJS(failureStore.searchData)} />
        </ReportBody>
      </>
    );
  }

  renderFilter() {
    if (!this.state.filterOpen) {
      return null;
    }

    const dataSearch = searchTerm => {
      this.setState({searchTerm});
      debounce((term) => this.handleChangeSearch(term), 500)(searchTerm);
    };

    return (
      <Filter
        isOpen={this.state.filterOpen}
        onApply={this.handleFilterApply}
        onClose={this.handleFilterClose}
        onChangeSearch={dataSearch}
        search={this.state.searchTerm}
        params={this.state.params}
      />
    );
  }
}

export default FailureLayout;
